function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoOverlay = require('../../lib/saito/ui/saito-overlay/saito-overlay');
var Transcript = /*#__PURE__*/function (_ModTemplate) {
  function Transcript(app) {
    var _this;
    _classCallCheck(this, Transcript);
    _this = _callSuper(this, Transcript, [app]);
    _this.name = 'Transcript';
    _this.slug = 'transcript';
    _this.description = 'Local multilingual transcript capture for Saito Talk';
    _this.categories = 'Utilities Communications';
    _this.status = 'alpha';
    _this["class"] = 'utility';
    _this.icon = 'fa-solid fa-file-lines';
    _this.runtime = null;
    _this.loading = null;
    if (app.BROWSER) {
      var recover = function recover() {
        _this.loadRuntime().then(function (runtime) {
          return runtime.recover();
        })["catch"](function (error) {
          return console.error('Transcript recovery:', error);
        });
      };
      app.connection.on('videocall-opened', recover);
      app.connection.on('show-call-interface', function () {
        recover();
        // The call UI may be replaced when switching between video and audio.
        setTimeout(function () {
          var _this$runtime;
          return (_this$runtime = _this.runtime) === null || _this$runtime === void 0 ? void 0 : _this$runtime.render();
        }, 0);
      });
      app.connection.on('saito-before-navigate', function (completion) {
        var _this$actionOverlay;
        _this.generation = (_this.generation || 0) + 1;
        (_this$actionOverlay = _this.actionOverlay) === null || _this$actionOverlay === void 0 || _this$actionOverlay.close();
        if (_this.runtime) completion.push(_this.runtime.beforeNavigate());
      });
      app.connection.on('videocall-stream', function (peer, stream) {
        var _this$runtime2;
        (_this$runtime2 = _this.runtime) === null || _this$runtime2 === void 0 || _this$runtime2.updateStream(peer, stream);
      });
      app.connection.on('videocall-peer-left', function (peer) {
        var _this$runtime3;
        return (_this$runtime3 = _this.runtime) === null || _this$runtime3 === void 0 ? void 0 : _this$runtime3.removePeer(peer);
      });
      app.connection.on('videocall-ended', function (completion) {
        var _this$actionOverlay2;
        (_this$actionOverlay2 = _this.actionOverlay) === null || _this$actionOverlay2 === void 0 || _this$actionOverlay2.close();
        // Also invalidate an import/model load if the call ends while it is loading.
        _this.generation = (_this.generation || 0) + 1;
        if (_this.runtime) completion.push(_this.runtime.endCall());
      });
    }
    return _this;
  }
  _inherits(Transcript, _ModTemplate);
  return _createClass(Transcript, [{
    key: "loadRuntime",
    value: function () {
      var _loadRuntime = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.loading) {
                this.loading = import(/* webpackIgnore: true */'/transcript/runtime.mjs').then(function (_ref) {
                  var TranscriptRuntime = _ref.TranscriptRuntime;
                  _this2.runtime = new TranscriptRuntime(_this2.app, {
                    createOverlay: function createOverlay() {
                      return new SaitoOverlay(_this2.app, _this2);
                    }
                  });
                  return _this2.runtime;
                })["catch"](function (error) {
                  _this2.loading = null;
                  throw error;
                });
              }
              return _context.a(2, this.loading);
          }
        }, _callee, this);
      }));
      function loadRuntime() {
        return _loadRuntime.apply(this, arguments);
      }
      return loadRuntime;
    }()
  }, {
    key: "showActionMenu",
    value: function showActionMenu(runtime, call) {
      var _this$actionOverlay3,
        _this3 = this;
      if ((_this$actionOverlay3 = this.actionOverlay) !== null && _this$actionOverlay3 !== void 0 && _this$actionOverlay3.visible) return;
      var generation = this.generation || 0;
      var callId = call.room_obj.call_id;
      var trigger = document.querySelector('.transcript-toggle-control');
      var overlay = new SaitoOverlay(this.app, this);
      this.actionOverlay = overlay;
      var keydown = function keydown(event) {
        if (event.key === 'Escape') overlay.close();
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          var buttons = _toConsumableArray(menu.querySelectorAll('button'));
          buttons[(buttons.indexOf(document.activeElement) + 1) % buttons.length].focus();
        }
      };
      overlay.show("\n      <div class=\"saito-modal transcript-action-menu\" role=\"dialog\" aria-label=\"Transcript\">\n        <div class=\"saito-modal-title\">Transcript</div>\n        <div class=\"saito-modal-content saito-menu-select-heavy\" role=\"menu\" aria-label=\"Transcript actions\">\n          <button type=\"button\" class=\"saito-modal-menu-option\" role=\"menuitem\" data-action=\"start\"><i class=\"fa-solid fa-play\" aria-hidden=\"true\"></i><span>Start</span></button>\n          <button type=\"button\" class=\"saito-modal-menu-option\" role=\"menuitem\" data-action=\"settings\"><i class=\"fa-solid fa-gear\" aria-hidden=\"true\"></i><span>Settings</span></button>\n        </div>\n      </div>", function () {
        document.removeEventListener('keydown', keydown);
        trigger === null || trigger === void 0 || trigger.setAttribute('aria-expanded', 'false');
        trigger === null || trigger === void 0 || trigger.focus();
      });
      var menu = document.querySelector("#saito-overlay".concat(overlay.ordinal, " .transcript-action-menu"));
      trigger === null || trigger === void 0 || trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', keydown);
      menu.querySelector('button').focus();
      menu.querySelectorAll('button').forEach(function (button) {
        button.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var context, _runtime$engine, _globalThis$siteMessa, _t;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                overlay.close();
                if (!(generation !== (_this3.generation || 0) || !call.streams.active || call.room_obj.call_id !== callId)) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                _context2.p = 1;
                if (!(button.dataset.action === 'settings')) {
                  _context2.n = 3;
                  break;
                }
                _context2.n = 2;
                return runtime.openSettings();
              case 2:
                if (generation === (_this3.generation || 0) && call.streams.active && call.room_obj.call_id === callId && !runtime.capturing && !runtime.finishing) _this3.showActionMenu(runtime, call);
                _context2.n = 4;
                break;
              case 3:
                // Preserve the Start click's user gesture for browser audio playback.
                context = runtime.prepareAudio();
                _context2.n = 4;
                return runtime.configureAndToggle(call, context);
              case 4:
                _context2.n = 6;
                break;
              case 5:
                _context2.p = 5;
                _t = _context2.v;
                if (context && context !== ((_runtime$engine = runtime.engine) === null || _runtime$engine === void 0 ? void 0 : _runtime$engine.context)) context.close()["catch"](function () {});
                console.error('Transcript:', _t);
                (_globalThis$siteMessa = globalThis.siteMessage) === null || _globalThis$siteMessa === void 0 || _globalThis$siteMessa.call(globalThis, 'Transcript could not start. Check speech model settings.', 5000);
              case 6:
                return _context2.a(2);
            }
          }, _callee2, null, [[1, 5]]);
        }));
      });
    }
  }, {
    key: "respondTo",
    value: function respondTo(type, obj) {
      var _this4 = this;
      if (type !== 'call-actions' || !this.app.BROWSER) return null;
      var action = function action(text, icon, method) {
        return {
          text: text,
          icon: icon,
          hook: "transcript-".concat(method, "-control"),
          callback: function () {
            var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
              var generation, _call$streams, _call$room_obj, runtime, call, _t2;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.p = _context3.n) {
                  case 0:
                    generation = _this4.generation || 0;
                    _context3.p = 1;
                    _context3.n = 2;
                    return _this4.loadRuntime();
                  case 2:
                    runtime = _context3.v;
                    if (!(generation !== (_this4.generation || 0))) {
                      _context3.n = 3;
                      break;
                    }
                    return _context3.a(2);
                  case 3:
                    call = _this4.app.modules.returnModule('Videocall');
                    if (!(!(call !== null && call !== void 0 && (_call$streams = call.streams) !== null && _call$streams !== void 0 && _call$streams.active) || ((_call$room_obj = call.room_obj) === null || _call$room_obj === void 0 ? void 0 : _call$room_obj.call_id) !== obj.call_id)) {
                      _context3.n = 4;
                      break;
                    }
                    return _context3.a(2);
                  case 4:
                    if (!(runtime.capturing || runtime.finishing)) {
                      _context3.n = 6;
                      break;
                    }
                    _context3.n = 5;
                    return runtime.toggle(call);
                  case 5:
                    _context3.n = 7;
                    break;
                  case 6:
                    _this4.showActionMenu(runtime, call);
                  case 7:
                    _context3.n = 9;
                    break;
                  case 8:
                    _context3.p = 8;
                    _t2 = _context3.v;
                    console.error('Transcript:', _t2);
                    siteMessage('Transcript could not start. Check that the server has all transcript files.', 5000);
                  case 9:
                    return _context3.a(2);
                }
              }, _callee3, null, [[1, 8]]);
            }));
            function callback() {
              return _callback.apply(this, arguments);
            }
            return callback;
          }(),
          event: function event(id) {
            var _this4$runtime;
            var button = document.getElementById(id);
            button.setAttribute('role', 'button');
            button.setAttribute('tabindex', '0');
            button.setAttribute('aria-label', text);
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-haspopup', 'menu');
            button.setAttribute('aria-expanded', 'false');
            button.onkeydown = function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                button.click();
              }
            };
            (_this4$runtime = _this4.runtime) === null || _this4$runtime === void 0 || _this4$runtime.render();
          }
        };
      };
      return [action('Transcript', this.icon, 'toggle')];
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      // Old deployments may still contain weights. Models are client downloads only.
      expressapp.use('/transcript/models', function (_req, res) {
        return res.sendStatus(404);
      });
      expressapp.use('/transcript', express["static"]("".concat(__dirname, "/web")));
    }
  }]);
}(ModTemplate);
module.exports = Transcript;